<template>
  <div class="fill-height of-y d-flex flex-column">
    <div
      v-if="!approvalsWithAccess.length && $store.state.ref.approvals.tabIndex === 0"
      class="fill-height d-flex align-center justify-center overline amber--text"
    >No Manual time approvals</div>
    <template v-else-if="$store.state.ref.approvals.tabIndex === 0">
      <div
          v-if="loadingReset"
          class="fill-height d-flex justify-center"
      >
        <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
        ></v-progress-circular>
      </div>
      <div
          v-else
          class="of-y"
          style="height: 100%"
      >
        <v-data-table
            ref="table"
            :headers="headers"
            :items="pendingTimesGrouped"
            :search="$store.state.ref.approvals.filterStr"
            :items-per-page="pendingTimesGrouped.length"
            hide-default-footer
            fixed-header
            class="fill-height of-y full-table"
            show-expand
            checkbox-color="primary"
            item-key="_id"
            selectable-key="_id"
            v-model="selectedManuals"
            show-select
            :item-class="getItemClass"
            single-expand
        >
          <template #item.actions="{ item }">
            <template v-if="!loadingItems.includes(item._id)">
              <v-btn
                  style="overflow: hidden !important;"
                  small
                  color="secondary"
                  class="mr-1"
                  :disabled="(selectedManuals.length ? !selectedManuals.includes(item) : false) || loadingItems.includes(item._id)"
                  @click="approve(item)"
              >Approve</v-btn>
              <v-btn
                  small
                  color="warning"
                  class="mx-1"
                  :disabled="(selectedManuals.length ? !selectedManuals.includes(item) : false) || loadingItems.includes(item._id)"
                  @click="remove(item)"
              >Remove</v-btn>
              <v-btn
                  small
                  color="error"
                  class="ml-1"
                  :disabled="(selectedManuals.length ? !selectedManuals.includes(item) : false) || loadingItems.includes(item._id)"
                  @click="showDeclineReason = true; declineManualTimeObj = item"
              >Decline</v-btn>
            </template>
            <template v-else>
              <div style="overflow: hidden !important; width: 100%" class="pt-3 d-flex justify-center">
                <v-progress-circular
                    indeterminate
                    size="24"
                    width="2"
                    style="overflow: hidden !important;"
                ></v-progress-circular>
              </div>
            </template>
          </template>
          
          <template v-slot:item.start="{ item }">{{format(item.start, 'yyyy-MM-dd HH:mm')}}</template>
          <template v-slot:item.end="{ item }">{{ item.end ? format(item.end, 'HH:mm') : null}}</template>
          <template v-slot:item.duration="{ item }">{{hoursDisplay(item.duration)}}</template>
          <template #item.employeeId="{item}">
            {{item.employeeName}}
          </template>
          <template #item.approvedRef="{item}">
            <div class="caption" style="height: auto !important;">
              <div style="height: auto !important;">{{item.approvedRef.by}}</div>
              <div style="height: auto !important;">{{format(item.approvedRef.on, 'yyyy-MM-dd hh:mm')}}</div>
            </div>
          </template>
          <template v-slot:item.label="{ item }">
            <div class="d-flex align-center overline" :class="`${$store.getters.labelsRef[item.label].color}--text`">
              <v-icon small :color="$store.getters.labelsRef[item.label].color" left>{{$store.getters.labelsRef[item.label].icon}}</v-icon>
              {{$store.getters.labelsRef[item.label].text}}
            </div>
          </template>
          <template #item.app="{item}">
            {{item.app}}{{item.members.length > 1 ? `(${item.members.length})` : ''}}
          </template>
          
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div
                  class="pt-3"
                  style="overflow: visible"
              >
                <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasMotivation">
                  <strong class="success--text">Motivation</strong>: {{ item.motivation }}
                </div>
                <div class="px-3 pb-3">
                  <v-simple-table v-if="item.members.length > 1" class="text-caption">
                    <thead>
                    <tr style="height: auto !important;">
                      <th class="text-left py-1" style="height: auto !important;">
                        Start
                      </th>
                      <th class="text-left py-1" style="height: auto !important;">
                        End
                      </th>
                      <th class="text-left py-1" style="height: auto !important;">
                        Duration
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="member in item.members"
                        :key="member._id"
                        style="height: auto !important;"
                    >
                      <td class="text-caption py-1" style="height: auto !important;">
                        {{format(new Date(member.start), 'yyyy-MM-dd HH:mm')}}
                      </td>
                      <td class="text-caption py-1" style="height: auto !important;">
                        {{format(new Date(member.end), 'HH:mm')}}
                      </td>
                      <td class="text-caption py-1" style="height: auto !important;">
                        {{hoursDisplay(member.duration)}}
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
            </td>
          </template>
        
        </v-data-table>
      
      </div>
    </template>
    <template v-else-if="$store.state.ref.approvals.tabIndex === 1">
      <div
          v-if="loadingRemoveManualTime"
          class="fill-height d-flex justify-center"
      >
        <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
        ></v-progress-circular>
      </div>
      
      <div
          v-else
          class="of-y"
          style="height: 100%"
      >
        <v-data-table
            ref="table"
            :headers="approvedHeaders"
            :items="approvedTimesGrouped"
            :search="$store.state.ref.approvals.filterStr"
            :items-per-page="approvedTimesGrouped.length"
            hide-default-footer
            fixed-header
            class="fill-height of-y full-table"
            show-expand
            checkbox-color="primary"
            item-key="_id"
            selectable-key="_id"
            v-model="selectedApproved"
            show-select
            :item-class="getItemClassApproved"
            single-expand
        >
        
          
          <template v-slot:item.start="{ item }">{{format(item.start, 'HH:mm')}}</template>
          <template v-slot:item.end="{ item }">{{ item.end ? format(item.end, 'HH:mm') : null}}</template>
          <template v-slot:item.duration="{ item }">{{hoursDisplay(item.duration)}}</template>
          <template #item.employeeName="{item}">
            {{item.employeeName}}
          </template>
          <template #item.approvedRef="{item}">
            <div class="caption" style="height: auto !important;">
              <div style="height: auto !important;">{{item.approvedRef.by}}</div>
              <div style="height: auto !important;">{{format(item.approvedRef.on, 'yyyy-MM-dd hh:mm')}}</div>
            </div>
          </template>
          <template v-slot:item.label="{ item }">
            <div class="d-flex align-center overline" :class="`${$store.getters.labelsRef[item.label].color}--text`">
              <v-icon small :color="$store.getters.labelsRef[item.label].color" left>{{$store.getters.labelsRef[item.label].icon}}</v-icon>
              {{$store.getters.labelsRef[item.label].text}}
            </div>
          </template>
          <template #item.app="{item}">
            {{item.app}}{{item.members.length > 1 ? `(${item.members.length})` : ''}}
          </template>
          
          <!--Actions-->
          <template v-slot:item.actions="{ item }">
            <template v-if="!loadingItems.includes(item._id)">
              <v-btn
                  small
                  color="warning"
                  class="ml-1"
                  :disabled="(selectedApproved.length ? !selectedApproved.includes(item) : false) || selectedApproved.includes(item._id)"
                  :laoding="(selectedApproved.length ? !selectedApproved.includes(item) : false) || selectedApproved.includes(item._id)"
                  @click="removeApproval(item)"
              >Remove</v-btn>
            </template>
            <template v-else>
              <div style="overflow: hidden !important; width: 100%" class="pt-3 d-flex justify-center">
                <v-progress-circular
                    indeterminate
                    size="24"
                    width="2"
                    style="overflow: hidden !important;"
                ></v-progress-circular>
              </div>
            </template>
          </template>
<!--          -->
<!--          <template v-slot:item.declined="{ item }">-->
<!--            <div class="d-flex align-center" :class="{ 'error&#45;&#45;text': item.declined }">{{ item.declined ? 'Declined' : 'Approved' }}</div>-->
<!--          </template>-->
<!--          -->
<!--          &lt;!&ndash;Motivation&ndash;&gt;-->
          
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div
                  class="pt-3"
                  style="overflow: visible"
              >
                <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasMotivation">
                  <strong class="success--text">Motivation</strong>: {{ item.motivation }}
                </div>
                
                <div class="px-3 pb-3">
                    <v-simple-table v-if="item.members.length > 1" class="text-caption">
                      <thead>
                      <tr style="height: auto !important;">
                        <th class="text-left py-1" style="height: auto !important;">
                          Start
                        </th>
                        <th class="text-left py-1" style="height: auto !important;">
                          End
                        </th>
                        <th class="text-left py-1" style="height: auto !important;">
                          Duration
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="member in item.members"
                          :key="member._id"
                          style="height: auto !important;"
                      >
                        <td class="text-caption py-1" style="height: auto !important;">
                          {{format(new Date(member.start), 'HH:mm')}}
                        </td>
                        <td class="text-caption py-1" style="height: auto !important;">
                          {{format(new Date(member.end), 'HH:mm')}}
                        </td>
                        <td class="text-caption py-1" style="height: auto !important;">
                          {{hoursDisplay(member.duration)}}
                        </td>
                      </tr>
                      </tbody>
                    </v-simple-table>
                </div>
                
                
              </div>
            </td>
          </template>
        </v-data-table>
      </div>
      
    </template>
    <template v-else-if="$store.state.ref.approvals.tabIndex === 2">
      <div
          v-if="loadingRemoveManualTime"
          class="fill-height d-flex justify-center"
      >
        <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
        ></v-progress-circular>
      </div>
      
      <div
          v-else
          class="of-y"
          style="height: 100%"
      >
        <v-data-table
            ref="table"
            :headers="declineHeaders"
            :items="declinedTimesGrouped"
            :search="$store.state.ref.approvals.filterStr"
            :items-per-page="declinedTimesGrouped.length"
            hide-default-footer
            fixed-header
            class="fill-height of-y full-table"
            show-expand
            checkbox-color="primary"
            item-key="_id"
            selectable-key="_id"
            v-model="selectedDeclined"
            show-select
            single-expand
            :item-class="getItemClassDeclined"
        >
          


          <template v-slot:item.start="{ item }">{{format(item.start, 'HH:mm')}}</template>
          <template v-slot:item.end="{ item }">{{ item.end ? format(item.end, 'HH:mm') : null}}</template>
          <template v-slot:item.duration="{ item }">{{hoursDisplay(item.duration)}}</template>
          <template #item.employeeId="{item}">
            {{item.employeeName}}
          </template>
          <template #item.declinedRef="{item}">
            <div class="caption" style="height: auto !important;">
              <div style="height: auto !important;">{{item.declinedRef.by}}</div>
              <div style="height: auto !important;">{{format(item.declinedRef.on, 'yyyy-MM-dd hh:mm')}}</div>
            </div>
          </template>
          <template v-slot:item.label="{ item }">
            <div class="d-flex align-center overline" :class="`${$store.getters.labelsRef[item.label].color}--text`">
              <v-icon small :color="$store.getters.labelsRef[item.label].color" left>{{$store.getters.labelsRef[item.label].icon}}</v-icon>
              {{$store.getters.labelsRef[item.label].text}}
            </div>
          </template>
          <template #item.app="{item}">
            {{item.app}}{{item.members.length > 1 ? `(${item.members.length})` : ''}}
          </template>
          
          <!--Actions-->
          <template v-slot:item.actions="{ item }">
            <template v-if="!loadingItems.includes(item._id)">
              <v-btn
                  small
                  color="warning"
                  class="ml-1"
                  :disabled="(selectedDeclined.length ? !selectedDeclined.includes(item) : false) || selectedDeclined.includes(item._id)"
                  :laoding="(selectedDeclined.length ? !selectedDeclined.includes(item) : false) || selectedDeclined.includes(item._id)"
                  @click="removeDeclined(item)"
              >Remove</v-btn>
            </template>
            <template v-else>
              <div style="overflow: hidden !important; width: 100%" class="pt-3 d-flex justify-center">
                <v-progress-circular
                    indeterminate
                    size="24"
                    width="2"
                    style="overflow: hidden !important;"
                ></v-progress-circular>
              </div>
            </template>
          </template>
          
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div
                  class="pt-3"
                  style="overflow: visible"
              >
                <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasDeclinedReason">
                  <strong class="error--text">Declined Reason</strong>: {{ item.declinedReason }}
                </div>
                
                <div class="text-body-2 px-3 pb-3" style="height: auto !important;" v-if="item.hasMotivation">
                  <strong class="success--text">Motivation</strong>: {{ item.motivation }}
                </div>
                
                <div class="px-3 pb-3">
                  <v-simple-table v-if="item.members.length > 1" class="text-caption">
                    <thead>
                    <tr style="height: auto !important;">
                      <th class="text-left py-1" style="height: auto !important;">
                        Start
                      </th>
                      <th class="text-left py-1" style="height: auto !important;">
                        End
                      </th>
                      <th class="text-left py-1" style="height: auto !important;">
                        Duration
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="member in item.members"
                        :key="member._id"
                        style="height: auto !important;"
                    >
                      <td class="text-caption py-1" style="height: auto !important;">
                        {{format(new Date(member.start), 'HH:mm')}}
                      </td>
                      <td class="text-caption py-1" style="height: auto !important;">
                        {{format(new Date(member.end), 'HH:mm')}}
                      </td>
                      <td class="text-caption py-1" style="height: auto !important;">
                        {{hoursDisplay(member.duration)}}
                      </td>
                    </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              
              
              </div>
            </td>
          </template>
        </v-data-table>
      </div>
    
    </template>

    <app-dlg
      title="Decline Manual Time"
      :show-dlg.sync="showDeclineReason"
      :default-padding="false"
      :show-loading="loadingDeclineManualTime"
      :dlg-width="400"
    >
      <template v-slot:default>
        <v-form
          ref="declineManualTimeForm"
          autocomplete="new-password"
          @submit="$event.preventDefault()"
        >
          <div class="pb-0 px-6">
            <v-textarea
              outlined
              label="Reason for declining manual time"
              :rows="4"
              v-model="declineReason"
              :rules="[validationRules.required]"
              ref="removeTa"
            ></v-textarea>
          </div>
        </v-form>
      </template>
      
      <template v-slot:actions>
        
        <v-btn
            small
            outlined
            size="small"
            class="ml-2"
            color="primary"
            @click="showDeclineReason = false"
        >Cancel</v-btn>
        
        <v-btn
            small
            class="ml-2"
            size="small"
            color="error"
            variant="contained"
            :disabled="loadingDeclineManualTime || !declineReason"
            :loading="loadingDeclineManualTime"
            @click="decline(declineManualTimeObj)"
        >Decline</v-btn>
      
      </template>
    </app-dlg>

  </div>
</template>

<script>
import {
  percentDisplay,
  hourDisplay,
  exportStats,
  objectifyArr,
  durationDisplay,
  arrSplice,
  nameSort, validationRules
} from "@/core/codeFunctions";
import AppDlg from "@/components/Shared/AppDlg";
import AppList from "@/components/Shared/AppList/AppList";
import {mapActions, mapGetters} from "vuex";
import {differenceInSeconds, format, isSameDay, isSameMonth, isSameYear} from "date-fns";
import {StatusMap} from "@/models/statusMap";

export default {
  components: {AppList, AppDlg},
  props: {
    vm: Object
  },
  data() {
    return {
      console,

      format,
      hoursDisplay: hourDisplay,
      percentDisplay: percentDisplay,
      loading: false,
      loadingReset: true,
      stats: [],
      headers: [
        {text: 'Employee', value: 'employeeName'},
        {text: 'Reason', value: 'app'},
        {text: 'Label', value: 'label'},
        {text: 'Start', value: 'start'},
        {text: 'End', value: 'end'},
        {text: 'Duration', value: 'duration'},
        {value: 'actions', align: 'end', width: 300, sortable: false},
        {text: 'More', value: 'data-table-expand'},
      ],
      approvedHeaders: [
        {text: 'Employee', value: 'employeeName'},
        {text: 'Reason', value: 'app'},
        {text: 'Label', value: 'label'},
        {text: 'Start', value: 'start'},
        {text: 'End', value: 'end'},
        {text: 'Duration', value: 'duration'},
        {text: 'Approved By', value: 'approvedRef'},
        {value: 'actions', align: 'end', width: 0, sortable: false},
        {text: 'More', value: 'data-table-expand'},
      ],
      declineHeaders: [
        {text: 'Employee', value: 'employeeName'},
        {text: 'Reason', value: 'app'},
        {text: 'Label', value: 'label'},
        {text: 'Start', value: 'start'},
        {text: 'End', value: 'end'},
        {text: 'Duration', value: 'duration'},
        {text: 'Declined By', value: 'declinedRef'},
        {value: 'actions', align: 'end', width: 0, sortable: false},
        {text: 'More', value: 'data-table-expand'},
      ],
      selectedManuals: [],
      loadingItems: [],

      approvedManualTimes: [],
      loadingRemoveManualTime: true,
      
      loadingApproved: false,
      selectedApproved: [],
      loadingRemoved: false,
      selectedDeclined: [],
      approvedTimes: [],
      declinedTimes: [],

      currentApprovedManualTimePage: 0,

      currentApprovedSkip: 0,
      currentDeclinedSkip: 0,
      currentApprovedSkipPre: 0,
      currentDeclinedSkipPre: 0,

      showDeclineReason: false,
      declineReason: null,
      loadingDeclineManualTime: false,
      declineManualTimeObj: null,

    }
  },
  watch: {
    '$store.state.ref.approvals.tabIndex': {
      immediate: true,
      deep: true,
      handler(val) {
        this.loadingReset = true
        this.selectedManuals = [];
        this.selectedApproved = [];
        this.selectedDeclined = [];
        if (val === 1)
          this.getApproved(null);
        if (val === 2)
          this.getDeclined(null);
      }
    },
    
    loadingReset: {
      immediate: true,
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.loadingReset = false
          }, 100)
        }
      }
    },
    
    '$store.state.ref.dashboard.selectedRange': {
      deep: true,
      handler(val) {
        this.loadingReset = true
        this.selectedManuals = [];
        this.selectedApproved = [];
        this.selectedDeclined = [];
        if (this.$store.state.ref.approvals.tabIndex === 1)
          this.getApproved(null);
        if (this.$store.state.ref.approvals.tabIndex === 2)
          this.getDeclined(null);
      }
    },
    showDeclineReason(val) {
      this.loadingDeclineManualTime = false
      this.declineReason = null;
      if (val) {
        setTimeout(() => {
          this.$refs.removeTa.focus()
        }, 500)
      }
    }
  },
  methods: {
    durationDisplay,
    ...mapActions(["gotoEmployee", "gotoEmployeeSettings", "gotoTeam", "updateSelections"]),

    async approve(item) {
      const ids = this.selectedManuals.length ? this.selectedManuals.map(v => v._id) : [item._id]
      
      const allItems = this.pendingTimesGrouped
          .filter(v => ids.includes(v._id))
          .reduce((a, i) => a.concat(i.members.map(v => v._id)), [])

      try {
        this.loadingItems.push(...ids)
        const res = await this.$newReq('POST', 'employees/approvePending', allItems)
        this.selectedManuals = [];
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loadingItems = this.loadingItems.filter(v => !ids.includes(v))
      }
    },
    
    async remove(item) {
      const ids = this.selectedManuals.length ? this.selectedManuals.map(v => v._id) : [item._id]
      
      const allItems = this.pendingTimesGrouped
          .filter(v => ids.includes(v._id))
          .reduce((a, i) => a.concat(i.members.map(v => v._id)), [])
      
      try {
        this.loadingItems.push(...ids)
        const res = await this.$newReq('POST', 'employees/removePending', allItems)
        this.selectedManuals = [];
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loadingItems = this.loadingItems.filter(v => !ids.includes(v))
      }
    },
    
    async decline(item) {
      if (this.showDeclineReason)
        if (!this.$refs.declineManualTimeForm.validate())
          return;
      
      this.loadingDeclineManualTime = true;
      
      const ids = this.selectedManuals.length ? this.selectedManuals.map(v => v._id) : [item._id]
      
      const allItems = this.pendingTimesGrouped
          .filter(v => ids.includes(v._id))
          .reduce((a, i) => a.concat(i.members.map(v => v._id)), [])
      
      try {
        this.loadingItems.push(...ids)
        const res = await this.$newReq('POST', 'employees/declinePending', {_ids: allItems, declineReason: this.declineReason})
        this.selectedManuals = [];
        this.loadingDeclineManualTime = false
        this.showDeclineReason = false
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loadingItems = this.loadingItems.filter(v => !ids.includes(v))
      }
      
    },
    
    async removeManualTime(item) {
      const ids = this.selectedManuals.length
        ? this.selectedManuals.map(obj => {
          return {
            _id: obj._id,
            declined: obj.declined
          }
        })
        : [{
          _id: item._id,
          declined: item.declined
        }]

      try {
        ids.forEach(id => {this.loadingItems.push(id)})

        const res = await this.$newReq(
          'POST',
          'employees/removeManualTime',
          {ids}
        )
        console.log(res);

        this.selectedManuals = [];
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        ids.forEach(id => {
          arrSplice(this.loadingItems, (spliceId) => spliceId._id === id._id)
        })
        ids.forEach(id => {
          arrSplice(this.approvedManualTimes, (spliceId) => spliceId._id === id._id)
        })
        if (this.approvedManualTimes.length === 0)
          await this.getApprovedManualTimes();
      }

    },
    
    async removeApproval(item) {
      
      const ids = this.selectedApproved.length ? this.selectedApproved.map(v => v._id) : [item._id]
      
      const allItems = this.approvedTimesGrouped
          .filter(v => ids.includes(v._id))
          .reduce((a, i) => a.concat(i.members.map(v => v._id)), [])
      
      try {
        this.loadingItems.push(...ids)
        const res = await this.$newReq('POST', 'employees/removeApprovedTimes', allItems)

        this.approvedTimes = this.approvedTimes.filter(v => !allItems.includes(v._id))
        this.selectedApproved = []

      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loadingItems = this.loadingItems.filter(v => !ids.includes(v))
      }
      
    },
    
    async removeDeclined(item) {
      
      const ids = this.selectedDeclined.length ? this.selectedDeclined.map(v => v._id) : [item._id]
      
      const allItems = this.declinedTimesGrouped
          .filter(v => ids.includes(v._id))
          .reduce((a, i) => a.concat(i.members.map(v => v._id)), [])
      
      try {
        this.loadingItems.push(...ids)
        const res = await this.$newReq('POST', 'employees/removeDeclinedTimes', allItems)
        
        this.declinedTimes = this.declinedTimes.filter(v => !allItems.includes(v._id))
        this.selectedDeclined = []
        
      } catch (e) {
        console.log(e)
        this.$snack.netWorkError()
      } finally {
        this.loadingItems = this.loadingItems.filter(v => !ids.includes(v))
      }
      
    },

    async exportDataDetail() {
      //     try {
      //         this.vm.$refs.navBarBody.$refs.dashboardToolbar.showLoadingExport = true;
      //         const stats = await this.$newReq('POST', 'dashboard/getEmployeesStatsDetail', {
      //             start: this.start,
      //             end: this.end,
      //         })
      //
      //         const dateTitle = (() => {
      //             if (!isSameYear(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
      //                 return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM yyyy')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
      //             if (!isSameMonth(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
      //                 return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd MMM')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
      //             if (!isSameDay(this.$store.state.ref.dashboard.selectedRange.start, this.$store.state.ref.dashboard.selectedRange.end))
      //                 return `${format(this.$store.state.ref.dashboard.selectedRange.start,'dd')} - ${format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')}`
      //             return format(this.$store.state.ref.dashboard.selectedRange.end,'dd MMM yyyy')
      //         })()
      //         exportStats(
      //             `Tracklogix Employees ${dateTitle} Detail`,
      //             'Employees',
      //             [{text: "Date", value: "date"}, ...this.$refs.table.headers],
      //             stats,
      //             this.$store.getters.labelsRef
      //         )
      //     } catch (e) {
      //         this.$snack.netWorkError();
      //     } finally {
      //         this.vm.$refs.navBarBody.$refs.dashboardToolbar.showLoadingExport = false;
      //     }
    },
    
    async getApproved() {
      try {
        this.loadingRemoveManualTime = true
        this.approvedTimes = [];
        this.approvedTimes = await this.$newReq(
            "POST",
            `employees/getApproved`,
            {
              start: this.$store.state.ref.dashboard.selectedRange.start,
              end: this.$store.state.ref.dashboard.selectedRange.end,
            }
        );
      } catch (e) {
        console.log(e);
        this.$snack.netWorkError();
      } finally {
        this.loadingRemoveManualTime = false
      }
    },
    
    async getDeclined() {
      try {
        this.loadingRemoveManualTime = true
        this.declinedTimes = [];
        this.declinedTimes = await this.$newReq(
            "POST",
            `employees/getDeclined`,
            {
              start: this.$store.state.ref.dashboard.selectedRange.start,
              end: this.$store.state.ref.dashboard.selectedRange.end,
            }
        );
      } catch (e) {
        console.log(e);
        this.$snack.netWorkError();
      } finally {
        this.loadingRemoveManualTime = false;
      }
    },
    
    
    async getApprovedManualTimes(direction) {

      if (direction === 'F') {
        this.currentApprovedManualTimePage += 100;

        this.currentApprovedSkipPre += this.currentApprovedSkip === 100 ? 100 : this.currentApprovedSkip;
        this.currentDeclinedSkipPre += this.currentDeclinedSkip === 100 ? 100 : this.currentDeclinedSkip;

      } else if (direction === 'B') {
        this.currentApprovedManualTimePage -= 100;

        this.currentApprovedSkipPre -= this.currentApprovedSkip === 100 ? 100 : this.currentApprovedSkip;
        this.currentDeclinedSkipPre -= this.currentDeclinedSkip === 100 ? 100 : this.currentDeclinedSkip;

        if (this.currentApprovedSkipPre < 0)
          this.currentApprovedSkipPre = 0;

        if (this.currentDeclinedSkipPre < 0)
          this.currentDeclinedSkipPre = 0;

      }

      this.loadingRemoveManualTime = true;
      try {
        this.approvedManualTimes = [];
        const approvedManualTimes = await this.$newReq(
          "POST",
          `employees/getApproveManualTime`,
          {
            approvedSkip: this.currentApprovedSkipPre,
            declinedSkip: this.currentDeclinedSkipPre
          }
        );
        this.approvedManualTimes = this.setDataTableItems(approvedManualTimes.arr);

        this.currentApprovedSkip = approvedManualTimes.manualTimeDataArrLength;
        this.currentDeclinedSkip = approvedManualTimes.declinedManualTimesArrLength;

      } catch (e) {
        console.log(e);
        this.$snack.netWorkError();
      } finally {
        this.loadingRemoveManualTime = false;
      }
    },
    setDataTableItems(arr) {
      return JSON.parse(JSON.stringify(arr)).map(app => {
        try {
          app.employee = this.employeesRef[app.employeeId];
          app.employeeName = app.employee.name;

          app.team = this.teamsRef[app.employee.teamId];
          app.teamName = app.team.name;

          app.labelId = 0;

          if (typeof app.start === "string")
            app.start = new Date(app.start);

          if (typeof app.end === "string")
            app.end = new Date(app.end);

          const stMap = this.manualTimeByMatch[app.match];
          if (stMap) {
            app.labelId = stMap.defaultLabel;
            if (stMap.teamLabels.length) {
              const teamSt = stMap.teamLabels.find(teamStObj => teamStObj.teamId === app.team._id);
              if (teamSt)
                app.labelId = teamSt.label;
            }
          }
          app.label = this.labelsRef[app.labelId];
        } catch (e) {
          console.log(e);
        }
        return app;
      })
    },
    doesManualTimeHaveAMotivation(item) {
      if (item.manualTimeMotivation)
        return true;
      if (item.manualTimeDetails)
        if (item.manualTimeDetails.manualTimeMotivation)
          return true;

      return false;
    },
    getItemClass(item) {
      if (item.members?.length > 1)
        return ''
      
      if (item.motivation)
        return ''
      
      return 'hide-expander'
    },
    
    getItemClassApproved(item) {
      if (item.members?.length > 1)
        return ''
      
      if (item.motivation)
        return ''
      
      return 'hide-expander'
    },
    
    getItemClassDeclined(item) {
      if (item.members?.length > 1)
        return ''
      
      if (item.motivation)
        return ''
      
      if (item.declinedReason)
        return ''
      
      return 'hide-expander'
    },
  },
  computed: {
    validationRules() {
      return validationRules
    },
    ...mapGetters([
      'access',
      'devicesWithAccess',
      'approvalsWithAccess',
      'employeesRef',
      'teamsRef',
      'labelsRef',
      'statusmaps',
      'statusmapsRef'
    ]),
    
    pendingTimesGrouped() {
      
      // headers: [
      //   {text: 'Employee', value: 'employeeName'},
      //   {text: 'Team', value: 'teamName'},
      //   {text: 'Reason', value: 'match'},
      //   {text: 'Label', value: 'label'},
      //   {text: 'Start', value: 'start'},
      //   {text: 'End', value: 'end'},
      //   {text: 'Duration', value: 'duration'},
      //   {text: 'Status', value: 'declined'},
      //   {value: 'actions', align: 'end', width: 250, sortable: false},
      //   {text: 'More', value: 'data-table-expand'},
      // ],
      
      const values = new Map()
      // Group It Here
      
      for (const val of this.approvalsWithAccess.filter(v => !v.declined)) {
        if (!values.has(val.groupUuid || val._id)) {
          values.set(val.groupUuid || val._id, {})
        }
        const ref = values.get(val.groupUuid || val._id)
        ref._id = val.groupUuid || val._id
        ref.hasMotivation = !!val.manualTimeMotivation
        if (ref.hasMotivation) {
          ref.motivation = val.manualTimeMotivation
        }
        ref.app = val.match
        ref.start = !ref.start ? new Date(val.start) : (ref.start < new Date(val.start) ? ref.start : new Date(val.start))
        ref.end = !ref.end ? new Date(val.end) : (ref.end > new Date(val.end) ? ref.end : new Date(val.end))
        ref.duration = (ref.duration || 0) + val.duration
        ref.employeeId = val.employeeId;
        
        if (!ref.employeeName) {
          const employee = this.$store.getters.employeeMap.get(ref.employeeId)
          ref.employeeName = employee.name
          const stMap = this.$store.getters.statusmapsByMatch[val.match]
          if (stMap)
            ref.label = stMap.teamLabels?.find(v => v.teamId === employee.teamId)?.label || stMap.defaultLabel
          ref.label = ref.label || 0
        }
        
        
        if (!ref.members)
          ref.members = []
        ref.members.push(val)
      }
      
      
      return [...values.values()]
    },
    
    declinedTimesGrouped() {
      
      const values = new Map()
      // Group It Here
      
      for (const val of this.declinedTimes) {
        
        if (!values.has(val.groupUuid || val._id)) {
          values.set(val.groupUuid || val._id, {})
        }
        const ref = values.get(val.groupUuid || val._id)
        ref._id = val.groupUuid || val._id
        ref.hasMotivation = !!val.manualTimeMotivation
        
        if (ref.hasMotivation) {
          ref.motivation = val.manualTimeMotivation
        }
        
        ref.hasDeclinedReason = !!val.declinedReason
        if (ref.hasDeclinedReason) {
          ref.declinedReason = val.declinedReason
        }
        ref.app = val.match
        ref.start = !ref.start ? new Date(val.start) : (ref.start < new Date(val.start) ? ref.start : new Date(val.start))
        ref.end = !ref.end ? new Date(val.end) : (ref.end > new Date(val.end) ? ref.end : new Date(val.end))
        ref.duration = (ref.duration || 0) + val.duration
        ref.employeeId = val.employeeId;

        if (!ref.employeeName) {
          const employee = this.$store.getters.employeeMap.get(ref.employeeId)
          ref.employeeName = employee.name
          const stMap = this.$store.getters.statusmapsByMatch[val.match]
          if (stMap)
            ref.label = stMap.teamLabels?.find(v => v.teamId === employee.teamId)?.label || stMap.defaultLabel
          ref.label = ref.label || 0
        }
        
        ref.declinedRef = {by: this.$store.getters.usersRef[val.declinedBy].name, on: new Date(val.declinedDate)}
        
        if (!ref.members)
          ref.members = []
        ref.members.push(val)
      }
      
      return [...values.values()]
    },
    
    approvedTimesGrouped() {
      const values = new Map()
      // Group It Here
      
      for (const val of this.approvedTimes) {
        if (!values.has(val.manualTimeDetails?.groupUuid || val._id)) {
          values.set(val.manualTimeDetails?.groupUuid || val._id, {})
        }
        const ref = values.get(val.manualTimeDetails?.groupUuid || val._id)
        ref._id = val.manualTimeDetails.groupUuid || val._id
        ref.isGroup = !!val.manualTimeDetails?.groupUuid
        ref.hasMotivation = !!val.manualTimeDetails?.manualTimeMotivation
        if (ref.hasMotivation) {
          ref.motivation = val.manualTimeDetails?.manualTimeMotivation
        }
        ref.app = val.app
        ref.start = !ref.start ? new Date(val.start) : (ref.start < new Date(val.start) ? ref.start : new Date(val.start))
        ref.end = !ref.end ? new Date(val.end) : (ref.end > new Date(val.end) ? ref.end : new Date(val.end))
        ref.duration = (ref.duration || 0) + val.duration
        ref.employeeId = val.employeeId;
        ref.label = val.label
        ref.employeeName = this.$store.getters.employeeMap.get(ref.employeeId).name
        ref.approvedRef = {by: this.$store.getters.usersRef[val.manualTimeDetails.approvedBy]?.name || 'System', on: new Date(val.manualTimeDetails.approvedDate)}
        if (!ref.members)
          ref.members = []
        ref.members.push(val)
      }
      
      
      return [...values.values()]
    },

    manualTimeByMatch() {
      return objectifyArr(this.statusmaps.filter(st => st.manualTime), 'match')
    },

    viewItems() {
      return this.setDataTableItems(this.approvalsWithAccess)
        .filter(item => !item.declined)
    },
    getDataTableItemsArr() {
      const viewItemsArr = JSON.parse(JSON.stringify(this.viewItems));
      
      const groups = {};

      viewItemsArr.forEach(obj => {
        const refGroupId = obj.groupUuid || obj._id
        
        if (!groups[refGroupId])
          groups[refGroupId] = [];

        obj.start = new Date(obj.start);
        obj.end = new Date(obj.end);

        groups[refGroupId].push(obj);
      });
      
      const groupedArrays = Object.values(groups);

      const approvals = [];
      
      for (let i = 0; i < groupedArrays.length; i++) {
        let totalDuration = 0;
        for (let k = 0; k < groupedArrays[i].length; k++)
          totalDuration += groupedArrays[i][k].duration;

        groupedArrays[i][0].duration = totalDuration;
        groupedArrays[i][0].arrLength = groupedArrays[i].length;


        if (groupedArrays[i].length > 1)
          groupedArrays[i][0].end = null;

        approvals.push(groupedArrays[i][0]);
      }

      return this.$store.state.ref.approvals.tabIndex === 0 ? approvals : this.approvedManualTimes;
    }
  },
  // mounted() {
  //   this.refreshData();
  // },

}
</script>

<style scoped>
.allOverflowHidden * {
  overflow: hidden !important;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: unset !important;
}

</style>